module.exports = __webpack_public_path__ + "static/media/flag-fi.7ba43c8d.webp";